/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type JSONWebKeySetDeletePreflight = {
  /**
   * Number of live remote_session_clients referencing this set. Deleting the set is refused while this is non-zero.
   */
  clientCount: number;
  /**
   * The client_id values of the referencing remote_session_clients, oldest first. Truncated when client_count exceeds the listing cap.
   */
  clientIds: Array<string>;
};

/** @internal */
export const JSONWebKeySetDeletePreflight$inboundSchema: z.ZodMiniType<
  JSONWebKeySetDeletePreflight,
  unknown
> = z.pipe(
  z.object({
    client_count: z.int(),
    client_ids: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_count": "clientCount",
      "client_ids": "clientIds",
    });
  }),
);

export function jsonWebKeySetDeletePreflightFromJSON(
  jsonString: string,
): SafeParseResult<JSONWebKeySetDeletePreflight, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => JSONWebKeySetDeletePreflight$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'JSONWebKeySetDeletePreflight' from JSON`,
  );
}
